import React from 'react';

export function GridSection({ id, title, subtitle, description, items = {} }) {
  // Items is an object like: { key1: { title: "", desc: "" }, ... }
  const itemKeys = Object.keys(items);

  return (
    <section id={id} className="relative w-full py-24 px-6 lg:px-16 bg-[#1f1f1f] text-[#f8f4f0]">
      <div className="max-w-7xl mx-auto w-full flex flex-col gap-16">
        
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-8 justify-between items-start lg:items-end border-b border-white/20 pb-8">
          <div className="w-full lg:w-1/2">
            <h2 className="text-sm md:text-md font-bold tracking-widest mb-3 uppercase border-b-2 border-white inline-block pb-1">
              {title}
            </h2>
            {subtitle && (
              <h3 className="text-4xl md:text-5xl font-extrabold leading-[1.1] tracking-tight mt-4">
                {subtitle}
              </h3>
            )}
          </div>
          {description && (
            <div className="w-full lg:w-1/2">
              <p className="text-lg text-white/70 font-mono leading-relaxed max-w-lg lg:ml-auto">
                {description}
              </p>
            </div>
          )}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {itemKeys.map((key) => {
            const item = items[key];
            return (
              <div key={key} className="bg-white/5 border border-white/10 rounded-xl p-8 hover:bg-white/10 transition-colors shadow-lg shadow-black/20 group">
                <div className="w-12 h-12 rounded-full bg-white/10 mb-6 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <div className="w-4 h-4 bg-[#f8f4f0] rounded-full" />
                </div>
                <h4 className="text-xl font-bold mb-3">{item.title}</h4>
                <p className="text-white/60 font-mono text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
